module.exports = __webpack_public_path__ + "static/media/public_black_24dp.9a61a24f.svg";